import store from '@/store';

let domain = 'ims.test';
let upload = 'https://www.quanneier.com'//'http://l.clcms.cn';

if (process.env.NODE_ENV == 'production') {
    domain = 'www.quanneier.com';
    upload = 'https://www.quanneier.com';
}
/**
 * 上传图片的显示网址
 */
export const UPLOAD = upload;
/**
 * 项目路由根目录
 */
export const HOST = '/';
/**
 * 项目域名
 */
export const DOMAIN = domain;

/**
 * API 接口根路径
 */
export const API_JAVA = '/java2api';

/* 注册路由 */
export function registerModel(name, model) {
    if (Object.keys(store.state).every(m => m !== name)) {
        store.registerModule(name, model);
    }
}



// WEBPACK FOOTER //
// ./src/utils/base.js